import { gql } from '@apollo/client'

export const NEW_USER_VERIFICATION = gql`
  query verifyInvitation($uuid: ID!, $invitationID: ID!) {
    verifyInvitation(uuid: $uuid, invitationID: $invitationID)
  }
`
